import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=d4c6f4e2&scoped=true&"
import script from "./copyright.vue?vue&type=script&lang=js&"
export * from "./copyright.vue?vue&type=script&lang=js&"
import style0 from "./copyright.vue?vue&type=style&index=0&id=d4c6f4e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c6f4e2",
  null
  
)

export default component.exports